/* unplugin-vue-components disabled */import { render } from "./templateDemeTextArea.vue?vue&type=template&id=9a8d3a1c&scoped=true"
import script from "./templateDemeTextArea.vue?vue&type=script&lang=js"
export * from "./templateDemeTextArea.vue?vue&type=script&lang=js"

import "./templateDemeTextArea.vue?vue&type=style&index=0&id=9a8d3a1c&scoped=true&lang=css"

import exportComponent from "/home/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9a8d3a1c"]])

export default __exports__